import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_maintenance/maintenance/")({
  beforeLoad: () => {
    throw redirect({ to: "/maintenance/work-orders", replace: true });
  },
});
